'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warningNotification = exports.successNotification = exports.showNotification = exports.removeAllNotifications = exports.navigateTo = exports.navigateBack = exports.initRouter = exports.initEnvironment = exports.infoNotification = exports.hideNotification = exports.errorNotification = exports.downloadFile = exports.autofill = undefined;

var _api = require('./api');

var _environment = require('./environment');

var _form = require('./form');

var _router = require('./router');

var _reactNotificationSystemRedux = require('react-notification-system-redux');

exports.autofill = _form.autofill;
exports.downloadFile = _api.downloadFile;
exports.errorNotification = _reactNotificationSystemRedux.error;
exports.hideNotification = _reactNotificationSystemRedux.hide;
exports.infoNotification = _reactNotificationSystemRedux.info;
exports.initEnvironment = _environment.initEnvironment;
exports.initRouter = _router.initRouter;
exports.navigateBack = _router.navigateBack;
exports.navigateTo = _router.navigateTo;
exports.removeAllNotifications = _reactNotificationSystemRedux.removeAll;
exports.showNotification = _reactNotificationSystemRedux.show;
exports.successNotification = _reactNotificationSystemRedux.success;
exports.warningNotification = _reactNotificationSystemRedux.warning;